import React, { FC } from 'react';
import { WrappedFieldsProps } from 'redux-form';
import { StyledTextarea, TextAreaLabel } from './TextArea.styles';

type TextAreaProps = {
  label: string | JSX.Element;
  id: string;
  placeholder?: string;
} & WrappedFieldsProps;

export const TextArea: FC<TextAreaProps> = ({ label, id, input, placeholder = '' }) => (
  <>
    <TextAreaLabel htmlFor={id}>{label}</TextAreaLabel>
    <StyledTextarea id={id} placeholder={placeholder} {...input} />
  </>
);
